import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import { VendorData } from '../apis/vendor.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ItemCard from '../components/ItemCard'
import ReceivingCreateForm from '../partials/ReceivingCreateForm/ReceivingCreateForm'

interface ReceivingCreateProps {}

interface ReceivingCreateState {
  item: ItemData | null
  vendor: VendorData | null
}

export default class ReceivingCreate
  extends Component<ReceivingCreateProps, ReceivingCreateState> {
  constructor (props: ReceivingCreateProps) {
    super(props)
    this.state = {
      item: null,
      vendor: null
    }
    this.handleItemSelect = this.handleItemSelect.bind(this)
    this.handleReset = this.handleReset.bind(this)
  }

  get itemCard () {
    const { item, vendor } = this.state
    const vendorName = vendor ? vendor.name : undefined
    const remainingQuantity = item && item.purchaseOrderItem ? item.purchaseOrderItem.remainingQuantity : undefined
    return item &&
      <ItemCard
        code={item.code}
        description={item.description}
        cpp={item.cpp}
        qpc={item.qpc}
        vendor={vendorName}
        remainingQuantity={remainingQuantity} />
  }

  handleItemSelect (item: ItemData, vendor: VendorData | null) {
    this.setState({ item, vendor })
  }

  handleReset () {
    this.setState({ item: null, vendor: null })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <ReceivingCreateForm
            onItemSelect={this.handleItemSelect}
            onReset={this.handleReset} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.itemCard}
        </ContentAside>
      </ContentLayout>
    )
  }
}
